export default __webpack_public_path__ + "static/media/handAlarm.35c844e6.svg";